import React from 'react'
import styles from './CommunitieSwitcher.module.scss'
import { Map } from "immutable";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import miscUtils from 'utils/miscUtils';
// import InfiniteScroll from 'react-infinite-scroll-component';
// import ScrollSpinner from 'components/scrollSpinner';
import { ReactComponent as PlusIcon } from 'assets/img/add.svg';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import ContentLoader from 'react-content-loader';
import { GroupService } from 'api/services/groups';
import { useAtom } from 'jotai';
import { showCommunitySwitcherAtom } from 'showMessageMenuAtom';
import { ReactComponent as LoadMoreIcon } from './3dots.svg';
import {
    DragDropContext,
    Droppable,
    Draggable,
} from 'react-beautiful-dnd';
import { toast } from 'react-toastify';

export interface ICommunitiesSidebarProps {
    [key: string]: any;
    userGroups?: any;
}


const CommunitieSwitcher: React.FC<ICommunitiesSidebarProps> = props => {
    const { global, isAuthed } = props;
    const { selectedGroup } = global;
    const [userGroups, setUserGroups] = React.useState<any>(null);
    const baseURL = miscUtils.getBaseDomain();

    function goToGroup(grp: any) {
        if (grp.id === selectedGroup.id) {
            return

        }
        const isCustomDomain = grp && grp.custom_domain && grp.custom_domain_ssl_active_at !== null;
        if (isCustomDomain) {
            window.location.assign(grp.url)
        } else {
            window.location.assign(miscUtils.getRedirectBaseUrl(grp))
        }
    }

    const [showCommunitySwitcher, setShowCommunitySwitcher] = useAtom(showCommunitySwitcherAtom);
    const sidebarValue = localStorage.getItem('sidebar');

    const shouldBeDisplayed = () => {
        if (window.innerWidth <= 991 && sidebarValue === undefined) {
            return false;
        } else if (window.innerWidth <= 991 && sidebarValue) {
            if (JSON.parse(sidebarValue).value === false) {
                return false;
            } else if (JSON.parse(sidebarValue).value === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    };

    React.useEffect(() => {
        const handleResize = () => {
            setShowCommunitySwitcher(shouldBeDisplayed());
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [sidebarValue]);

    React.useEffect(() => {
        fetchUserGroups();
    }, [isAuthed])


    const fetchUserGroups = () => {
        if (isAuthed) {
            GroupService.getInstance()
                .getUserGroupsForCommunitySidebar(isAuthed)
                .then((response: any) => {
                    setUserGroups(response);
                }).catch((error: any) => console.error(error))
        }
    }

    const loadMoreUserGroups = () => {
        if (userGroups) {
            GroupService.getInstance()
                .LoadmoreUserGroupsForCommunitySidebar(`${userGroups.next_page_url}&side-bar=true`)
                .then((response: any) => {
                    setUserGroups((prev: any) => ({
                        ...response,
                        data: [...prev.data, ...response.data],
                    }));
                }).catch((error: any) => console.error(error))
        }
    }

    const handleDragEnd = (result: any) => {
        const { source, destination } = result;
        if (!destination) return;

        const reordered = Array.from(userGroups.data);
        const [movedItem] = reordered.splice(source.index, 1);
        reordered.splice(destination.index, 0, movedItem);

        // Build final position payload (starting from 1 instead of 0)
        const positionPayload: Record<string, number> = {};
        reordered.forEach((group: any, index: number) => {
            positionPayload[group.id] = index + 1; // index starts from 1
        });

        if (!isAuthed) return

        GroupService.getInstance()
            .arrageUserGroupsForCommunitySidebar(isAuthed, { position: positionPayload })
            .then((response: any) => {
                toast(`${response.message}`, {
                    type: 'success',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            }).catch((error: any) => console.error(error))

        setUserGroups((prev: any) => ({
            ...prev,
            data: reordered
        }));
    };


    const isGroupDataRequired =
        window.location.hostname !== 'my.group.app' &&
        window.location.hostname !== 'group.localhost' &&
        window.location.hostname !== 'staging.group.app';

    function showCommunitySwitcherFn() {
        return (
            window.location.pathname !== "/login" &&
            window.location.pathname !== "/signup" &&
            window.location.pathname !== "/verify-account" &&
            window.location.pathname !== "/create-community" &&
            window.location.pathname !== "/signin" &&
            window.location.pathname !== "/forgot-password" &&
            window.location.pathname !== "/reset-password" &&
            window.location.pathname.split("/")[1] !== "pages" &&
            window.location.pathname.split("/")[1] !== "pages-preview" &&
            !(
                window.location.pathname.split("/")[2] === "landing-pages" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            !(
                window.location.pathname.split("/")[2] === "certificates" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            !(
                window.location.pathname.split("/")[2] === "workflows" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            window.location.pathname !== "/upgrade" &&
            window.location.pathname !== "/onboarding" &&
            window.location.pathname !== "/creategroup" &&
            window.location.pathname !== "/plan-subscription" &&
            window.location.pathname !== "/plan-subscription/checkout"

        );
    }

    if (showCommunitySwitcherFn() && isAuthed && selectedGroup && selectedGroup.id && isGroupDataRequired && showCommunitySwitcher) {
        return (
            <aside
                className={`${styles.CommunitieSwitcher}`} id='communities-sidebar'>
                {
                    (!userGroups || (!selectedGroup))
                        ?
                        <div style={{ marginTop: '16px', width: '100%' }}>
                            {
                                Array(6).fill('').map((_e, i) => (
                                    <ContentLoader
                                        speed={2}
                                        width={16}
                                        height={13}
                                    >
                                        <rect x="3" y="0" rx="2" ry="2" width="8" height="8" />
                                    </ContentLoader>
                                ))
                            }
                        </div>
                        :
                        <>
                            {
                                userGroups && userGroups.data && userGroups.data.length > 0 &&
                                <PerfectScrollbar
                                    options={{
                                        wheelPropagation: false,
                                        suppressScrollX: true, // Add this to only show vertical scrollbar
                                    }}
                                    className={`${styles.CommunitieSwitcher__scrollarea}`}
                                >

                                    <DragDropContext onDragEnd={handleDragEnd}>
                                        <Droppable droppableId="groups">
                                            {(provided: any) => (
                                                <div
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                >
                                                    {userGroups.data.filter((group: any) => !group.exclude_from_sidebar).map((group: any, index: number) => (
                                                        <Draggable key={group.id} draggableId={String(group.id)} index={index}>
                                                            {(provided: any) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={styles.CommunitieSwitcher__group}
                                                                    onClick={() => goToGroup(group)}
                                                                    title={group.name}
                                                                >
                                                                    <CommunityDetails group={group} selectedGroup={selectedGroup} />
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>


                                    {
                                        userGroups && userGroups.next_page_url &&
                                        <div
                                            onClick={() => loadMoreUserGroups()}
                                            className={styles.CommunitieSwitcher__loadmore}>
                                            <LoadMoreIcon />
                                        </div>
                                    }

                                    <div
                                        className={styles.CommunitieSwitcher__add}
                                        onClick={() => {
                                            if (props.globalUser && !props.globalUser.verified) {
                                                window.location.assign(`${baseURL}/verify-account?r=true`);
                                                return;
                                            }
                                            window.location.assign(`${baseURL}/creategroup`);
                                        }}
                                    >
                                        <PlusIcon />

                                    </div>
                                    {/* </InfiniteScroll> */}
                                </PerfectScrollbar>
                            }
                        </>
                }
            </aside>
        )
    } else {
        return <></>
    }

}

const CommunityDetails = ({ group, selectedGroup }: { group: any, selectedGroup: any }) => {
    const [invalidImage, setInvalidImage] = React.useState(false);

    const onImageError = () => {
        setInvalidImage(true);
    }

    return (
        <div
            style={{
                borderColor: group.id === selectedGroup.id ? '#365de6' : 'transparent'
            }}
            className={styles.CommunitieSwitcher__group__image}>
            {group.unread_notifications > 0 &&
                <div className={styles.CommunitieSwitcher__group__image__unread}>
                    {
                        group.unread_notifications <= 9
                            ?
                            group.unread_notifications
                            :
                            '9+'
                    }
                </div>
            }
            {(group.profile_image && !invalidImage) ?
                <img
                    src={group.profile_image}
                    alt="commmunity-profile-image"
                    onError={onImageError}
                />
                :
                <div
                    className={styles.CommunitieSwitcher__group__image__initials}
                    data-color={miscUtils.getColorInitial(`${group.name}`)}
                >
                    {miscUtils.getNameInitials(group.name)}
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state: Map<string, any>, ownProps: ICommunitiesSidebarProps) => {
    const groups: any = Map(state.get("group", {})).toJS();
    const global = Map(state.get("global", {})).toJS() as any;
    const globalUser: any = state.getIn(["authorize", "user"]);
    const isAuthed: string = state.getIn(["authorize", "uid"]) as string;

    return {
        userGroups: groups.userGroups,
        global,
        globalUser,
        isAuthed
    };
};

export default withRouter(connect(mapStateToProps)(CommunitieSwitcher as any) as any) as any;